import { fbDB } from "../config/firebase";
import { AWARDS_WATCH_ON, AWARDS_WATCH_OFF } from "./types";

export const awardsWatchOn = () => async dispatch => {
  fbDB.ref("/awards").on("value", snapshot =>
    dispatch({
      type: AWARDS_WATCH_ON,
      payload: snapshot.val()
    })
  );
};

export const awardsWatchOff = () => async dispatch => {
  fbDB.ref("/awards").off();
  return dispatch({
    type: AWARDS_WATCH_OFF,
    payload: null
  });
};

export const awardsTargetToggle = (cCode, uid) => async dispatch => {
  fbDB.ref(`/awards/${cCode}/absent`).transaction(data => {
    if (data === null) {
      return [uid];
    } else if (data.filter(v => v === uid).length) {
      return data.filter(v => v !== uid);
    } else if (!data.filter(v => v === uid).length) {
      return [...data, uid];
    }
  });
};
